import { computed, defineComponent } from '@vue/composition-api';
import CollapseMenu from '@/components/CollapseMenu/CollapseMenu.vue';
import { MenuItems } from '@/views/Brand/Applications/Components/Sidebar/sidebar.constants';
import OfferMenuItems from './OfferMenuItems.vue';
export default defineComponent({
    name: 'OfferMenu',
    components: {
        OfferMenuItems,
        CollapseMenu,
    },
    setup(_, ctx) {
        const menuItems = computed(() => [
            {
                name: MenuItems.OFFERS,
                label: ctx.root.$t('offer-menu.offers').toString(),
                expanded: true,
            },
        ]);
        return {
            menuItems,
            MenuItems,
        };
    },
});
